import { ISliderFormControlOptions } from "../slider-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSSliderOptions implements _SSControlOptionsBase<'slider'> {

  constructor(
    private _initialOptions?: ISliderFormControlOptions
  ) {

    this._initOptions()
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'slider'>(this, this._initialOptions);
  }

  dispose() {

  }
}
